import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotifierComponent, NotifierStatus } from './notifier/notifier.component';

@Injectable()
export class SnackBarService {
    constructor(
        public snackBar: MatSnackBar,
        public zone: NgZone,
    ) {
    }

    public successMessage(message: string): void {
        this.zone.run(() => {
            const snackBar = this.snackBar.open(
                message,
                "OK",
                {
                    panelClass: "success-message",
                    verticalPosition: 'top',
                    duration: 10000
                });
            snackBar.onAction().subscribe(() => {
                snackBar.dismiss();
            })
        });
    }

    public notifierMessage(context, title: string, messageList: Array<any>, time?: number,
        status: NotifierStatus = 'default'): void {

        this.zone.run(() => {
            let dados = {
                message: title,
                context: context,
                list: messageList,
                status: status
            }
            const snackBar =
                this.snackBar.openFromComponent(NotifierComponent,
                    {
                        panelClass: "notifier",
                        verticalPosition: 'bottom',
                        horizontalPosition: 'right',
                        data: dados,
                        duration: time
                    });
            snackBar.onAction().subscribe(() => {
                snackBar.dismiss();
            })
        });
    }

    public errorMessage(message: string): void {
        this.zone.run(() => {
            const snackBar = this.snackBar.open(
                message,
                "OK",
                {
                    panelClass: "error-message",
                    verticalPosition: 'top',
                    duration: 5000,
                });
            snackBar.onAction().subscribe(() => {
                snackBar.dismiss();
            })
        });
    }


    public warnMessage(message: string): void {
        this.zone.run(() => {
            const snackBar = this.snackBar.open(
                message,
                "OK",
                {
                    panelClass: "warn-message",
                    verticalPosition: 'top',
                    duration: 8000
                });
            snackBar.onAction().subscribe(() => {
                snackBar.dismiss();
            })
        });
    }

    public unexpectedMessage(code?): void {
        if (code) {
            code = '[' + code + ']';
        } else {
            code = '';
        }
        this.zone.run(() => {
            const snackBar = this.snackBar.open(
                "Ocorreu um erro inesperado, tente novamente!" + code,
                "OK",
                {
                    panelClass: "error-message",
                    verticalPosition: 'top',
                    duration: 6000
                });
            snackBar.onAction().subscribe(() => {
                snackBar.dismiss();
            })
        });
    }

    public ExternalNotification(mensagem: string): void {
        if (!('Notification' in window)) {
            alert('Este navegador não suporta notificações.');
            return;
        }

        if (Notification.permission === 'granted') {
            this.exibirNotificacao(mensagem);
            return;
        }

        Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
                this.exibirNotificacao(mensagem);
            }
        });
    }

    private exibirNotificacao(text: string): void {
        const notification = new Notification('Clinicall', {
            body: text,
            icon: 'assets/imagens/clinic_all.png'
        });

        notification.onclick = () => {
            window.focus();
            notification.close();
        };
    }

}